export default __webpack_public_path__ + "static/media/i-information.02c03eab.svg";